import type { Optional } from '..';
import { isNumber } from '../../number';

export function withDefault<Value, DefaultValue extends Value = Value>(value: Optional<Value>, defaultValue: DefaultValue): Value {
  if (isNumber(value) && isNaN(value)) {
    return defaultValue;
  }

  return value ?? defaultValue;
}

export type StrictOmit<T, K extends keyof T> = {
  [P in keyof T]: P extends K ? never : T[P];
};